// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  OutboundRule,
  LoadBalancerOutboundRulesListOptionalParams,
  LoadBalancerOutboundRulesGetOptionalParams,
  LoadBalancerOutboundRulesGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a LoadBalancerOutboundRules. */
export interface LoadBalancerOutboundRules {
  /**
   * Gets all the outbound rules in a load balancer.
   * @param resourceGroupName The name of the resource group.
   * @param loadBalancerName The name of the load balancer.
   * @param options The options parameters.
   */
  list(
    resourceGroupName: string,
    loadBalancerName: string,
    options?: LoadBalancerOutboundRulesListOptionalParams,
  ): PagedAsyncIterableIterator<OutboundRule>;
  /**
   * Gets the specified load balancer outbound rule.
   * @param resourceGroupName The name of the resource group.
   * @param loadBalancerName The name of the load balancer.
   * @param outboundRuleName The name of the outbound rule.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    loadBalancerName: string,
    outboundRuleName: string,
    options?: LoadBalancerOutboundRulesGetOptionalParams,
  ): Promise<LoadBalancerOutboundRulesGetResponse>;
}
